import { render, staticRenderFns } from "./KnowledgeItemsListView.vue?vue&type=template&id=bd990e06"
import script from "./KnowledgeItemsListView.vue?vue&type=script&lang=js"
export * from "./KnowledgeItemsListView.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeItemsListView.vue?vue&type=style&index=0&id=bd990e06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports